/**
 * Created by Ivan on 17.05.2026
 */

const SeasonPassStartWindow = Prefab.createWindow(
    (mission) => (bundles[`season_pass_${mission.logic.period}`] ? "season_pass_start_window" : "season_pass_fallback_windows"),
    (mission) => (bundles[`season_pass_${mission.logic.period}`] ? "start_window_prefab_json" : "fallback_start_window_prefab_json"),
    {
        theme: (mission) => (bundles[`season_pass_${mission.logic.period}`] ? bundles[`season_pass_${mission.logic.period}`].jsons[`theme_${mission.logic.period}`] : undefined),
        bundles: SeasonPassLogic.listWindowBundles
    }
);

const SeasonPassStartWindowFallback = Prefab.createWindow(
    "season_pass_fallback_windows",
    "fallback_start_window_prefab_json"
);
